import React, {useState} from 'react'
import { useDispatch } from 'react-redux'
import Modal from "../../components/utility/Modal"
import Toaster from "../../components/utility/Toaster"
import { deleteChallan } from '../../redux/actions/challanActions'

const DeleteChallan = ({id}) => {

  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)

    // toaster states
    const [toaster, setToaster] = useState(false)
    const [toasterMessage, setToasterMessage] = useState("")
    const [toasterType, setToasterType] = useState("")

  const handelSubmit = (e) => {
    e.preventDefault();
    setButtonLoading(true)
    setLoading(true)
    dispatch(deleteChallan(id))
    .then(res=>{
      setButtonLoading(false)
      setLoading(false)
      if (!res.success) {
        handleToaster(res.message, "error")
      } else {
        handleToaster("Deleted successfully", "success")
      }
      closeModal()
    })
  }

  const closeModal = () => {
    document.getElementById("closeDeleteChallanModal").click()
  }

  const handleToaster = (message, icon) => {
    setToaster(true)
    setToasterMessage(message)
    setToasterType(icon)
  }

  return (
    <section>
        <Modal targetName={"deleteChallan"}>
            <div className='p-lg-5 p-1 text-center'>
                <h1>Delete Challan</h1>
                <div className="row">
                    <div className="col-12 col-lg-6 mt-5">
                        <button className="btn btn-primary shadow w-100" onClick={closeModal}>Cancel</button>
                    </div>
                    <div className="col-12 col-lg-6 mt-5">
                        <button className="btn btn-danger shadow w-100" onClick={handelSubmit}>{buttonLoading ? <div className="spinner-border button-spinner" role="status"><span className="visually-hidden">Loading...</span></div> : "Delete"}</button>
                    </div>
                </div>
            </div>
            <button className='d-none' data-bs-dismiss="modal" id="closeDeleteChallanModal">Close modal</button>
        </Modal>
        <Toaster text={toasterMessage} toasterType={toasterType} toaster={toaster} setToaster={setToaster} />
    </section>
  )
}

export default DeleteChallan